interface Props {
    label: string;
    value: string | number;
    labelStyle?: string;
    valueStyle?: string;
    componentsStyle?: string;
}

export default function BasicInfoItem({
    label,
    value,
    componentsStyle = "",
    labelStyle = "mb-0.5 text-[10px] tracking-wide text-gray-500 sm:text-[11px]",
    valueStyle = "break-words text-xs font-medium leading-5 text-gray-800",
}: Props) {

    return (
        <div className={`min-w-0 ${componentsStyle}`}>
            <p className={labelStyle}>
                {label}
            </p>
            <p className={valueStyle}>
                {value !== "" && value !== null && value !== undefined
                    ? value
                    : "-"}
            </p>

        </div>
    );
}